/**
 * Fetches a test-ticket attachment as a Blob (with headers) – used by the
 * shared AttachmentPanel + AttachmentViewerModal when mode="test".
 */
export async function fetchTestAttachmentBlob(
  tabId: string,
  testTicketId: number,
): Promise<{ blob: Blob; mimeType: string; fileName: string }> {
  const res = await fetch(
    `/api/admin/tabs/${tabId}/test-tickets/${testTicketId}/attachment?disposition=inline`,
    { credentials: "include" },
  );
  if (!res.ok) throw new Error(`Attachment download failed (${res.status})`);
  const mimeType = res.headers.get("content-type") ?? "application/octet-stream";
  const disp = res.headers.get("content-disposition");
  const fileName = parseFilename(disp) ?? `attachment-${testTicketId}`;
  const blob = await res.blob();
  return { blob, mimeType, fileName };
}

function parseFilename(disposition: string | null): string | null {
  if (!disposition) return null;
  const star = /filename\*=([^;]+)/i.exec(disposition);
  if (star) {
    const v = star[1].trim();
    const idx = v.indexOf("''");
    const raw = idx >= 0 ? v.slice(idx + 2) : v;
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain?.[1] ?? null;
}
